import { trackEvent } from '@zep/logger/tracking';
import { AI_BUILDER_GUIDE_FALLBACK_URL } from '../constants';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
export const AiBuilderComposerDisclaimer = () => {
  const copy = useAiBuilderChatCopy();
  const guideUrl = copy.composer.learnMoreUrl.startsWith('http') ? copy.composer.learnMoreUrl : AI_BUILDER_GUIDE_FALLBACK_URL;
  return <p className="flex w-full items-center justify-center gap-x-2xs text-caption-lg-medium text-assistive" data-sentry-component="AiBuilderComposerDisclaimer" data-sentry-source-file="AiBuilderComposerDisclaimer.tsx">
      <span className="min-w-0 truncate">{copy.composer.disclaimer}</span>
      <a href={guideUrl} target="_blank" rel="noopener noreferrer" className="shrink-0 text-link" onClick={() => {
      trackEvent('quiz_ai_builder_guide_click', {
        url: guideUrl
      });
    }}>
        {copy.composer.learnMore}
      </a>
    </p>;
};